import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import '../../styles/Notification.css';
import Can from '../auth/Can';
import Unauthorized from '../auth/Unauthorized';
import { AuthConsumer } from '../auth/AuthContext';
import Protected from '../auth/Protected';
import NotificationList from './NotificationList';
import ScheduledPushesList from './ScheduledPushesList';
import NewNotification from './NewNotification';
import EditNotification from './EditNotification';
import ContextProvider from './NotificationContext';
import i18n from './messages.json';
import usePageTitle from '../../utils/use-page-title';

const Notifications = () => {
  const [editedNotificationId, setEditedNotificationId] = useState(null);

  usePageTitle('Push');

  const renderNotificationHome = () => (
    <ContextProvider>
      <div className="Notif-container">
        <Container>

          <Protected privilege="notification:publish" customBlankClassName="btn">
            <Link to="https://lookerstudio.google.com/u/0/reporting/1ZirGF73BE7sWN2CAWtEHAu5gpZqLHppB/page/KG3uB"
              className="Notif-reports-btn"
              target="_blank"
              rel="noopener noreferrer">
                <b>{i18n.ink.notification.buttons.reports}</b>
                <img src="images/external-link.png" className="Notif-reports-icon" alt="Ga data studio"/>
            </Link>

            <NewNotification />
          </Protected>

          <Row className="error-log">
            <Col>
              <NotificationList
                type="errors"
                openEditNotification={(notificationId) => setEditedNotificationId(notificationId)}
              />
            </Col>
          </Row>

          <Row className="scheduled-pushes-log">
            <Col>
              <ScheduledPushesList
                openEditNotification={(notificationId) => setEditedNotificationId(notificationId)}
              />
            </Col>
          </Row>

          <Row className="activity-log">
            <Col>
              <NotificationList
                type="activity-log"
                open={true}
                openEditNotification={(notificationId) => setEditedNotificationId(notificationId)}
              />
            </Col>
          </Row>
        </Container>
        {editedNotificationId && (
          <EditNotification
            id={editedNotificationId}
            closeEditNotification={() => setEditedNotificationId(null)}
          />
        )}
      </div>
    </ContextProvider>
  );

  return (
    <AuthConsumer>
      {({ user }) => (
        <Can
          role={user.role}
          perform="notification:view"
          yes={() => renderNotificationHome()}
          no={() => <Unauthorized />}
        />
      )}
    </AuthConsumer>
  );
};

export default Notifications;
